import { ReactNode, HTMLAttributes, CSSProperties } from "react";
import { BaseComponentProps, Variant } from "../types";
import "./BaseLayout.scss";

export interface BaseLayoutProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "className">,
    BaseComponentProps {
  children: ReactNode;
  variant?: Variant;
  className?: string;
  style?: CSSProperties;
  id?: string;
}

export const AntdLayout: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const layoutClass = ["antd-layout", `antd-layout--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={layoutClass} data-testid={testId} {...props}>
      {children}
    </div>
  );
};

export const AntdHeader: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const headerClass = ["antd-header", `antd-header--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={headerClass} data-testid={testId} {...props}>
      {children}
    </header>
  );
};

export const AntdContent: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const contentClass = ["antd-content", `antd-content--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <main className={contentClass} data-testid={testId} {...props}>
      {children}
    </main>
  );
};

export const AntdFooter: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const footerClass = ["antd-footer", `antd-footer--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <footer className={footerClass} data-testid={testId} {...props}>
      {children}
    </footer>
  );
};

export const AntdSider: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const siderClass = ["antd-sider", `antd-sider--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <aside className={siderClass} data-testid={testId} {...props}>
      {children}
    </aside>
  );
};

export default AntdLayout;
